
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import DrinksScreens from './drinks'
import BurritosScreens from './burritos'
import VeggieScreens from './veggie'
import TacosScreen from './tacos'
import QuesadillasScreen from './quesadillas'
import SandwitchScreen from './sandwitch'
import LunchScreen from './lunch'
import translateMenu from '../../helpers/translateMenu';

function Index({setshowCategories}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const [menus, setMenus] = useState([]);
    const [showListProduct, setShowListProduct] = useState(false);
    const [showDrinks, setShowDrinks] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
     const [dishs, setdishs] = useState(false);
    const [drinks, setdrinks] = useState(false);


    const [showBurritos, setShowBurritos] = useState(false);
    const [showVeggie, setShowVeggie] = useState(false);
    const [showTacos, setshowTacos] = useState(false);
    const [showQuesadilla, setshowQuesadilla] = useState(false);
    const [showSandwitch, setshowSandwitch] = useState(false);
     const [showLunch, setshowLunch] = useState(false);
    
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
            setMenus(data);
        });
    }, []);



    
          useEffect(() => {
                menus.map((item) => {
                    if (item.id === 479) {
                        setdrinks(item);
                    }
                });
          }, [menus]);
        
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={true} setShowListProduct={setshowCategories} goHome={setshowCategories} setShowSpecials={() => {
            setShowSpecials(true)
        }}>
                <div  style={{padding: '0 20px', overflow: 'scroll', height: 765}}>
                    <div style={{display:"flex", justifyContent: 'space-between', flexWrap: "wrap"}}>
                        {menus.map((item, key) => {

                            if (![226, 225, 224, 234, 228, 238].includes(item.id)) {
                                 return (
                                <div
                                    key={key}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: 335,
                                        position: 'relative',
                                        cursor: 'pointer',
                                        overflow: 'hidden',
                                        borderRadius: 20,
                                        marginBottom: 10
                                    }}
                                         onClick={() => { 
                                      
                                             if (item.id === 369) {
                                                 setShowDrinks(true)
                                             }else if (item.id === 375) {
                                                 setShowBurritos(true)
                                             } else if (item.id === 452) {
                                                 setShowVeggie(true)
                                             }else if (item.id === 379) {
                                                 setshowTacos(true)
                                             }else if (item.id === 374) {
                                                 setshowQuesadilla(true)
                                             }else if (item.id === 386) {
                                                 setshowSandwitch(true)
                                             }else if (item.id === 377) {
                                                 setshowLunch(true)
                                             } else {
                                                setShowListProduct(true);
                                                setdishs(item);
                                             }
                                          
                                        
                                    }}
                                >
                                    {/* Imagen de fondo */}
                                    <img
                                        src={`https://tumenu.online/images/categories/icons/${item.icon}`}
                                        style={{
                                           
                                            width: '100%',
                                            height: 195,
                                            objectFit: 'cover',
                                            borderRadius: 20,
                                            transition: 'transform 0.3s ease-in-out'
                                        }}
                                    />

                                    {/* Overlay con efecto hover */}
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%',
                                            backgroundColor: 'rgba(0, 0, 0, 0.3)',
                                            opacity: 1,
                                            transition: 'opacity 0.3s ease-in-out'
                                        }}
                                        className="overlay"
                                    ></div>

                                    <p
                                        className="text-shadow"
                                        style={{
                                            position: 'absolute',
                                            fontFamily: 'LondrinaSolidBlack',
                                            color: 'white',
                                          
                                            fontSize: 35,
                                            transition: 'transform 0.3s ease-in-out'
                                        }}
                                    >
                                        {langEng ? 
                                    `${item.name}`
                                : 
                                `${translateMenu(
                                    i18n.language, 
                                    item.language, 
                                    item.name, 
                                    'name'
                                )}`
                                        }
                                    </p>

                                   
                                </div>
                            );
                            }
                           
                        })}

                    </div>
                   
                </div>

                {showListProduct && <ListProducts
                    dishs={dishs}
                    setShowListProduct={setShowListProduct}
                    goHome={setshowCategories}
                />}

                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setshowCategories} />}
                {showDrinks && <DrinksScreens setshowCategories={setShowDrinks} />}
                
                {showBurritos && <BurritosScreens setshowCategories={setShowBurritos} />}
                {showVeggie && <VeggieScreens setshowCategories={setShowVeggie} />}
                {showTacos && <TacosScreen setshowCategories={setshowTacos} />}
                {showQuesadilla && <QuesadillasScreen setshowCategories={setshowQuesadilla} />}
                {showSandwitch && <SandwitchScreen setshowCategories={setshowSandwitch} />}
                {showLunch && <LunchScreen setshowCategories={setshowLunch} />}
            </LayoutContent>
        </div>
    );
}
export default Index;